module.exports = __webpack_public_path__ + "img/hand-move.936ad7c0.gif";